var map = {
	"./auth/auth.module": [
		"./src/app/login/auth/auth.module.ts",
		"common",
		"auth.module"
	],
	"./compras/compra.module": [
		"./src/app/restricted/compras/compra.module.ts",
		"common",
		"compra.module"
	],
	"./estoque/estoque.module": [
		"./src/app/restricted/estoque/estoque.module.ts",
		"common",
		"estoque.module"
	],
	"./home/home.module": [
		"./src/app/restricted/home/home.module.ts",
		"common",
		"home.module"
	],
	"./hubspot/hubspot.module": [
		"./src/app/restricted/hubspot/hubspot.module.ts",
		"common",
		"hubspot.module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login.module"
	],
	"./recovery/recovery.module": [
		"./src/app/login/recovery/recovery.module.ts",
		"common",
		"recovery.module"
	],
	"./reset/reset.module": [
		"./src/app/login/reset/reset.module.ts",
		"common",
		"reset.module"
	],
	"./restricted/restricted.module": [
		"./src/app/restricted/restricted.module.ts",
		"restricted.module"
	],
	"./usuario/usuario.module": [
		"./src/app/restricted/usuario/usuario.module.ts",
		"common",
		"usuario.module"
	],
	"./vendas/venda.module": [
		"./src/app/restricted/vendas/venda.module.ts",
		"common",
		"venda.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main